import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

const UnitFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    quantity: z.coerce.number().min(1, 'Quantity is required'),
    strip_quantity: z.coerce.number().optional(),
});

export type TUnitForm = z.infer<typeof UnitFormSchema>;

type UnitFormProps = {
    initialValues: TUnitForm;
    onSubmit?: (data: TUnitForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const UnitForm: FC<UnitFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Unit Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={UnitFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'flex flex-col space-y-4'}>
                    <TextField<TUnitForm>
                        name={'name'}
                        label={'Name'}
                        placeholder={'Enter unit name'}
                    />

                    <TextField<TUnitForm>
                        name={'quantity'}
                        label={'Quantity'}
                        placeholder={'Enter quantity'}
                    />

                    <TextField<TUnitForm>
                        name={'strip_quantity'}
                        label={'Strip Quantity'}
                        placeholder={'Enter strip quantity'}
                    />

                    <div className={''}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};

UnitForm.displayName = 'UnitForm';
